import * as t from 'io-ts';

import {ApiType} from '../../../models/api/apiTypes';
import {CompanyModel} from '../../../models/api/companyModel';
import {fetchApiAsync} from '../../../services/http/http';
import {ResourceListPagination, ResourceTableCommonPageType} from './resourceListPaginationHelpers';

/*
 * Types.
 */

type ResourceListNoPaginationPageType<TResource> = ResourceTableCommonPageType<TResource>;

interface ResourceListNoPaginationConfig<TResource> {
  makeUrl: (company: CompanyModel) => string;
  apiType: ApiType<t.Type<ReadonlyArray<TResource>, unknown>>;
}

/*
 * Helpers.
 */

/**
 * Abstracts the logic to fetch a list of items without pagination.
 * Useful for using resource list and mutations where pagination is not available.
 *
 * @param config The config of the pagination.
 */
export function makeResourceListNoPagination<TResource>(
  config: ResourceListNoPaginationConfig<TResource>,
): ResourceListPagination<TResource, undefined, ResourceListNoPaginationPageType<TResource>> {
  const {makeUrl, apiType} = config;

  return {
    fetchApi: async (pageParam, company, cancelToken) => {
      const url = makeUrl(company);

      const items = await fetchApiAsync(apiType, url, {cancelToken});
      return {items};
    },
    getNextPageParam: () => undefined,
  };
}
